export const freeShippingIv = (values) => {
    return {
        id: values.id,
        carrier_name: values.carrier_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "0.00",
        show_estimated_delivery_date: values.show_estimated_delivery_date,
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "2",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "16",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || "All",
        zone: values.zone || "",
        status: values.status || 1,
        amount: values.amount || "",
        amount_type: values.amount_type || "",
        table_based_on: values.table_based_on || "subtotalAfterDiscounts",
        rate_based_on: values.rate_based_on || "perOrder",
    }
}

export const freeShippinVS_ = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }

    // to remove start -----
    // if (!values.order_preparation_time) {
    //     errors.order_preparation_time = "This field is required"
    // }
    // if (!values.orders_received_past_this_time_on_the_next_day) {
    //     errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    // }
    // if (!values.estimated_transit_time_from) {
    //     errors.estimated_transit_time_from = "This field is required"
    // } else if (parseInt(values.estimated_transit_time_from) < 1) {
    //     errors.estimated_transit_time_from = "Invalid"
    // }
    // if (!values.estimated_transit_time_to) {
    //     errors.estimated_transit_time_to = "This field is required"
    // } else if (parseInt(values.estimated_transit_time_to) < 1) {
    //     errors.estimated_transit_time_to = "Invalid"
    // }
    // if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
    //     parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
    //     errors.estimated_transit_time_to = "invalid"
    // }
    // to remove start -----
    if(values.show_estimated_delivery_date) {
        // VALIDATIONS:- estimated_transit_time_from
        if (values.estimated_transit_time_from === "") {
            errors.estimated_transit_time_from = "This field is required"
        } 
        if (parseInt(values.estimated_transit_time_from) === 0) {
            errors.estimated_transit_time_from = "Value should not be 0"
        }
        
        // VALIDATIONS:- estimated_transit_time_to
        if (values.estimated_transit_time_to === "") {
            errors.estimated_transit_time_to = "This field is required"
        } 
        if (parseInt(values.estimated_transit_time_to) === 0) {
            errors.estimated_transit_time_to = "Value should not be 0"
        }        
        if ((values.estimated_transit_time_from !== "" && parseInt(values.estimated_transit_time_from) !== 0)) {
            if(parseInt(values.estimated_transit_time_to) < parseInt(values.estimated_transit_time_from)) {
                errors.estimated_transit_time_to = "should not be less than " + values.estimated_transit_time_from
            }
        }
    
        // VALIDATIONS:- order_preparation_time
        if (!values.order_preparation_time) {
            errors.order_preparation_time = "This field is required"
        }
    
        if(values.order_preparation_time == 4) {
            // VALIDATIONS:- custom_time_frame_from
            if (values.custom_time_frame_from === "") {
                errors.custom_time_frame_from = "This field is required"
            } 
            if (parseInt(values.custom_time_frame_from) === 0) {
                errors.custom_time_frame_from = "Value should not be 0"
            }
    
            // VALIDATIONS:- custom_time_frame_to
            if (values.custom_time_frame_to === "") {
                errors.custom_time_frame_to = "This field is required"
            } 
            if (parseInt(values.custom_time_frame_to) === 0) {
                errors.custom_time_frame_to = "Value should not be 0"
            }        
            if ((values.custom_time_frame_from !== "" && parseInt(values.custom_time_frame_from) !== 0)) {
                if(parseInt(values.custom_time_frame_to) < parseInt(values.custom_time_frame_from)) {
                    errors.custom_time_frame_to = "should not be less than " + values.custom_time_frame_from
                }
            }
        }
        
        if (!values.orders_received_past_this_time_on_the_next_day) {
            errors.orders_received_past_this_time_on_the_next_day = "This field is required"
        }
    
        if (!values.days_when_you_pack_orders) {
            errors.days_when_you_pack_orders = "This field is required"
        }
    }


    if (values.shipping_type === "flat_rate" && !values.amount) {
        errors.amount = "Required"
    }
    if (values.shipping_type === "flat_rate" && !values.amount_type) {
        errors.amount_type = "Required"
    }

    if (!values.shipping_region) {
        errors.shipping_region = "This field is required"
    }

    return errors
}

